import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { QueryModel } from '../share/paginationquery.model';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { TerminalOverviewReport } from './terminal-overview-report.type';
import { Zone } from '../share/zones/zone.model';
import { Group } from '../share/groups/group.model';
import { CostCenterService } from '../share/costCenter/costcenter.service';
import { ReportsService } from '../share/reports/report.service';
import { AppSettings } from '../../settings';

@Component({
  selector: 'app-terminal-overview-report',
  templateUrl: './terminal-overview-report.component.html',
  styleUrls: ['./terminal-overview-report.component.css'],
  providers: [CostCenterService, ReportsService]
})
export class TerminalOverviewReportComponent implements OnInit {

  terminalOverviews: TerminalOverviewReport[] = [];
  currentPageNumber = 1;
  currentDetailsIndex = -1;
  isLoadDetails = false;
  connectionStatusId: number;
  connectionStatuses: any[] = [];
  zones: Zone[] = [];
  allZones: Zone = new Zone();
  allZonesWithoutClosed: Zone = new Zone();
  zoneId: number = null;
  zoneIds: number[] = [];
  groups: Group[] = [];
  allGroups: Group = new Group();
  groupId: string = null;
  groupIds: string[] = [];
  isLoading = false;
  order = '';
  recordsPerPage: number;
  query: QueryModel = new QueryModel();
  filterValue: string;
  readonly collapsedDetailsIndex = -1;

  constructor(
    private _translate: TranslateService,
    private _costCenterService: CostCenterService,
    private _spinner: NgxSpinnerService,
    private _toastrService: ToastrService,
    private _reportsService: ReportsService,
    private _settings: AppSettings
  ) {
    this.recordsPerPage = _settings.recordsPerPage;
  }

  ngOnInit() {
    this.getZones();
    this.getGroups();
  }

  getZones() {
    this._costCenterService.httpGetZones()
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
        data => {
          if (data !== undefined) {
            this.zones = data;

            this.allZonesWithoutClosed.name = 'AllZonesWithoutClosed';
            this.allZonesWithoutClosed.zoneId = -10;

            this.allZones.name = 'AllZones';
            this.allZones.zoneId = -11;

            this.zones.unshift(this.allZonesWithoutClosed, this.allZones);
          }
        },
        err => {
          throw err;
        });
  }

  getGroups() {
    this._costCenterService.httpGetGroups()
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
        data => {
          if (data !== undefined) {
            this.groups = data;
            this.allGroups.name = 'AllGroups';

            this.groups.unshift(this.allGroups);
          }
        },
        err => {
          throw err;
        });
  }

  search() {
    if (this.zoneId != null && this.groupId != null) {
      this.isLoading = true;

      if (this.zoneId === -10) {
        this.zoneIds = this.zones.filter(z => !z.name.toLowerCase().includes('zatvoren')).map(z => z.zoneId);
      } else if (this.zoneId === -11) {
        this.zoneIds = this.zones.map(z => z.zoneId);
      } else {
        this.zoneIds = [];
        this.zoneIds.push(this.zoneId);
      }

      if (this.groupId === 'AllGroups') {
        this.groupIds = this.groups.map(g => g.name);
      } else {
        this.groupIds = [];
        this.groupIds.push(this.groupId);
      }

      if (this.isDetailsPreviewOpen()) {
        this.closeDetailsPreview();
      }
      this.loadTerminalOverviewReportList();
    } else {
      this._translate.get('Messages.InvalidSearchTerminalOverview').subscribe(translated => {
        this._toastrService.warning(translated);
      });
    }
  }

  loadTerminalOverviewReportList() {
    this._spinner.show();
    this.currentPageNumber = 1;

    this._reportsService.httpGetTerminalOverviewReport(this.zoneIds, this.groupIds)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      (data: TerminalOverviewReport[]) => {
        if (data !== undefined) {
          this.terminalOverviews = data.filter(item => item.terminalId > 0);

          if (this.terminalOverviews === undefined || this.terminalOverviews.length === 0) {
            this._translate.get('Messages.NoData').subscribe(translated => {
              this._toastrService.warning(translated);
            });
          }
        }
      },
      err => {
        throw err;
      }, () => this.isLoading = false
    );
  }

  sort(propertyName) {
    if (this.currentDetailsIndex > this.collapsedDetailsIndex) return;
    if (this.order === propertyName) {
      this.order = '-' + propertyName;
    } else if (this.order === '-' + propertyName) {
      this.order = propertyName;
    } else {
      this.order = propertyName;
    }
  }

  getTerminalNameAndCityAsString(report) {
    if (report.city !== null && report.city !== undefined)
      return report.name + ' ' + '(' + report.city + ')';
    return report.name;
  }

  onSearchTextChange() {
    if (this.isDetailsPreviewOpen()) {
      this.closeDetailsPreview();
    }
  }

  closeDetailsPreview() {
    this.isLoadDetails = false;
    this.currentDetailsIndex = this.collapsedDetailsIndex;
  }

  onKeyDown(event) {
    if (event.key === 'Enter') {
      this.removeFocus();
    }
  }

  isDetailsPreviewOpen() {
    return this.isLoadDetails && this.currentDetailsIndex !== this.collapsedDetailsIndex ? true : false;
  }

  removeFocus() {
    (document.activeElement as HTMLElement).blur();
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-overview-report/terminal-overview-report.component.ts